/* eslint-disable camelcase */
import React, { useState, useEffect, useRef } from 'react'
import { getGDCRoadMapFiles, postGDCRoadMapFile } from '@auteco/services/gdcServices'
import { Box, IconButton, Typography } from '@material-ui/core'
import MaterialTable, { MTableToolbar } from 'material-table'
import GetAppIcon from '@material-ui/icons/GetApp'
import BackupIcon from '@material-ui/icons/Backup'
import SendIcon from '@material-ui/icons/Send'
import CancelIcon from '@material-ui/icons/Cancel'
import { toBase64 } from '@auteco/utils/toBase64'
import { downloadFile } from '@auteco/utils/downloadFile'
import { useStyles } from './styles'




const FinancialModel = ({ partner, isEnabled }) => {
    const [files, setFiles] = useState([])
    const [uploadedFile, setUploadedFile] = useState({})

    const classes = useStyles()
    const inputFileRef = useRef(null);

    const getFiles = async () => {
        const { hoja_ruta } = await getGDCRoadMapFiles({ partner })
        if (hoja_ruta) {
            setFiles(hoja_ruta)
        }
    }

    const columns = [
        {
            title: 'Nombre',
            field: 'nombre',
            editable: 'never'
        },
        {
            title: 'Fecha',
            field: 'fecha',
            editable: 'never'
        },
        {
            title: 'Descargar',
            field: 'descargar',
            render: (rowData) => (
                <div className={classes.iconDownContainer}>
                    <IconButton
                        className={classes.iconDown}
                        onClick={() => downloadFile({ urlFile: rowData.url_archivo, name: rowData.nombre })}

                    >
                        <GetAppIcon />
                    </IconButton>
                </div>
            ),
        }
    ]

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0]
        setUploadedFile(selectedFile)
    }

    const handleSendFile = async () => {
        const fileBase64 = await toBase64(uploadedFile)
        const body = {
            nombre: uploadedFile.name,
            archivo: fileBase64,
            solicitante: partner
        }
        const { success } = await postGDCRoadMapFile({ params: body })
        if (success) {
            getFiles()
            setUploadedFile({})
        }
        inputFileRef.current.value = null
    }

    useEffect(() => {
        getFiles()
    }, [])
    return (
        <>
            <MaterialTable
                title='Modelo financiero'
                columns={columns}
                data={files}
                style={{ width: '600px' }}
                components={{
                    Toolbar: (props) => (
                        <div
                            style={{
                                background: '#FCFCFC',
                                color: '#E2A233',
                            }}
                        >
                            <MTableToolbar {...props} />
                            <input
                                ref={inputFileRef}
                                accept=".xls, .xlsx"
                                className={classes.fileInput}
                                id="file-input-financial"
                                type="file"
                                onChange={handleFileChange}
                            />
                            <label htmlFor="file-input-financial">
                                {uploadedFile?.name &&
                                    <Box className={classes.fileInfoContainer}>
                                        <Typography className={classes.fileName}>{uploadedFile?.name}</Typography>
                                        <IconButton
                                            onClick={() => setUploadedFile({})}
                                        >
                                            <CancelIcon />
                                        </IconButton>
                                        <IconButton
                                            color="primary"
                                            onClick={handleSendFile}
                                        >
                                            <SendIcon />
                                        </IconButton>
                                    </Box>
                                }
                                {!uploadedFile?.name &&
                                    <Box sx={{ display: 'flex' }}>
                                        <IconButton
                                            color="primary"
                                            component="span"
                                            className={classes.iconButton}
                                            disabled={!isEnabled}
                                        >
                                            <Typography>Subir archivo</Typography>
                                            <BackupIcon />
                                        </IconButton>
                                    </Box>
                                }
                            </label>
                        </div>
                    ),
                }}
                options={{
                    headerStyle: {
                        backgroundColor: '#F6F6F6',
                        color: '#161615',
                        fontSize: '14px',
                        fontWeight: 700,
                        textAlign: 'center',
                    }
                }}
            />
        </>
    )
}

export { FinancialModel }